export const POLICIES_TAG_EVENTS = {
  GENERATE_POLICY: 'GeneratePolicy',
  GENERATE_POLICY_SUCCESS: 'GeneratePolicySuccess',
  GENERATE_POLICY_FAILED: 'GeneratePolicyFailed',
  DOWNLOAD_POLICY: 'DownloadPolicy',
  CONFIG_POLICY: 'ConfigPolicy',
};